package com.patronat.top.library.media.domain.models


data class FileRegistration(val mediaId: String,
                            val publicUrl: String)